var Vue = require('vue');
module.exports = new Vue();



// WEBPACK FOOTER //
// ./src/common/js/bus.js